<script setup>
import { SearchIcon, XIcon } from 'vue-tabler-icons';
import { computed, watch } from 'vue';
import { useVillagesStore } from '@/stores/villages';
import { storeToRefs } from 'pinia';

const props = defineProps({
  closesearch: {
    type: Function,
    required: false
  }
});

const villagesStore = useVillagesStore();
const { searchQuery } = storeToRefs(villagesStore);
const onClear = () => {
  villagesStore.clearSearch();
  if (props.closesearch) props.closesearch();
};

const model = computed({
  get: () => searchQuery.value,
  set: (v) => villagesStore.setSearchQuery(v ?? '')
});

watch(
  () => searchQuery.value,
  (nv, ov) => {
    if (props.closesearch && ov && !nv) {
      props.closesearch();
    }
  }
);
</script>

<template>
  <!-- ---------------------------------------------- -->
  <!-- searchbar -->
  <!-- ---------------------------------------------- -->
  <v-text-field
    v-model="model"
    persistent-placeholder
    placeholder="સભ્ય, ગામ, વ્યવસાય શોધો..."
    color="primary"
    variant="outlined"
    hide-details
  >
    <template v-slot:prepend-inner>
      <SearchIcon stroke-width="1.5" size="17" class="text-lightText SearchIcon" />
    </template>
    <template v-slot:append-inner>
      <v-btn
        color="lighterror"
        icon
        rounded="sm"
        variant="flat"
        size="small"
        class="text-error SearchSetting ml-3 d-block d-lg-none"
        aria-label="Clear search"
        @click="onClear"
      >
        <XIcon stroke-width="1.5" size="20" />
      </v-btn>
    </template>
  </v-text-field>
</template>
